import { render } from "./FacilityProperty.vue?vue&type=template&id=3e37f3d0"
import script from "./FacilityProperty.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilityProperty.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/facility/FacilityProperty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e37f3d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e37f3d0', __exports__)) {
    console.log('reload')
    api.reload('3e37f3d0', __exports__)
  }
  
  module.hot.accept("./FacilityProperty.vue?vue&type=template&id=3e37f3d0", () => {
    console.log('re-render')
    api.rerender('3e37f3d0', render)
  })

}


export default __exports__